import {
	BackButton,
	Card,
	CardTitle,
	Duration,
	PlayerName,
	Role,
	RoleImage,
	RoleName,
	Roles,
	Title,
	Wrapper,
	Description,
	Task,
	TaskCounter,
	TaskList,
	TopWrapper,
	RelativeAnchor,
} from './IntroductionScreen.styled';
import CrossIcon from '../../images/cross.svg';
import DefaultUserIcon from '../../images/user.svg';
import GradientButton from '@/common/components/custom/buttons/GradientButton';
import Loading from '@/common/components/Loading';
import { useNavigate, useParams } from 'react-router-dom';
import useIntroductionScreen from './hooks/useIntroductionScreen';

function IntroductionScreen() {
	const navigate = useNavigate();
	const { id } = useParams();

	const { langData, scene, userData } = useIntroductionScreen(id!);

	return !scene ? (
		<Loading />
	) : (
		<TopWrapper>
			<Wrapper>
				<RelativeAnchor>
					<BackButton onClick={() => navigate('/learn/scenes-v3')}>
						<img src={CrossIcon} alt='exit' />
					</BackButton>
				</RelativeAnchor>
				<Title>{scene.name}</Title>
				<Duration>{langData.twoToFiveMinutes}</Duration>
				<Card>
					<CardTitle>{langData.role}</CardTitle>
					<Roles>
						<Role color='#F7F7FB'>
							<RoleImage
								src={userData.user_profile?.base64 ?? DefaultUserIcon}
							></RoleImage>
							<PlayerName>{userData.name}</PlayerName>
							<RoleName>{scene.customerRole}</RoleName>
						</Role>
						<Role color='#EDEFFE'>
							<RoleImage src={userData.speaker.icon.base64}></RoleImage>
							<PlayerName>{userData.speaker.name}</PlayerName>
							<RoleName>{scene.tutorRole}</RoleName>
						</Role>
					</Roles>
				</Card>
				<Card>
					<CardTitle>{langData.description}</CardTitle>
					<Description>{scene.description}</Description>
				</Card>
				<Card>
					<CardTitle>{langData.task}:</CardTitle>
					<TaskList>
						{scene.tasks.map((t) => (
							<Task>
								<TaskCounter>{t.id}</TaskCounter> {t.name}
							</Task>
						))}
					</TaskList>
				</Card>
			</Wrapper>

			<GradientButton
				style={{ width: 250, aspectRatio: '5.5/1' }}
				title={'Rozpocznij'}
				onClick={() => navigate(`/learn/scenes-v3/${id}`)}
			/>
		</TopWrapper>
	);
}

export default IntroductionScreen;
